export default __webpack_public_path__ + "static/media/8.987f6360.jpg";